// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"205":"record_detailed","334":"artface","922":"edit","926":"record"}[chunkId] + "." + {"205":"ee2743cb","334":"851720a1","922":"88a52967","926":"72f0fb48"}[chunkId] + ".css";
};